export default "__VITE_ASSET__XkgDCp12__"